import React from "react";
import "./HomeScreenSkeleton.css";
import LoadingContent from "../../components/LoadingContent";

const skeletonProducts = [
  {
    id: "1",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/z2ofx7hl2yq6rkn7bcjy.avif",
    alt: "Beddo ürün görseli 1",
  },
  {
    id: "2",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/yzfwnbeeu8gzcmz87wje.avif",
    alt: "Beddo ürün görseli 2",
  },
  {
    id: "3",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/qbstmyfaih3dumx0xbdd.avif",
    alt: "Beddo ürün görseli 3",
  },
  {
    id: "4",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/dflcow3fqlbftglslzjf.avif",
    alt: "Beddo ürün görseli 4",
  },
  {
    id: "5",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/s2fimi9mraycakpllt0g.avif",
    alt: "Beddo ürün görseli 5",
  },
  {
    id: "6",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/k8wim8yoejcujssprnht.avif",
    alt: "Beddo ürün görseli 6",
  },
  {
    id: "7",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/bpgy37xj6vvkynmtucrf.avif",
    alt: "Beddo ürün görseli 7",
  },
  {
    id: "8",
    image:
      "https://beddo-media.ams3.cdn.digitaloceanspaces.com/beddo-assets/skeleton/gwdx688tyntdebuaoblf.avif",
    alt: "Beddo ürün görseli 8",
  },
];

export default function HomeScreenSkeleton() {
  return (
    <div className="home-skeleton-page">
      <div className="home-skeleton-top-message">
        <LoadingContent content={"Ürünler yükleniyor"} />
      </div>

      <div className="home-skeleton-grid">
        {skeletonProducts.map((item) => (
          <div
            className="home-skeleton-card white-shadowbackground"
            key={item.id}
          >
            <div className="home-skeleton-image-wrap">
              <img
                className="home-skeleton-image"
                src={item.image}
                alt={item.alt}
                loading="eager"
              />
              <div className="home-skeleton-image-overlay shimmer"></div>
            </div>

            <div className="home-skeleton-content">
              <div className="home-skeleton-line home-skeleton-line-title shimmer"></div>
              <div className="home-skeleton-line home-skeleton-line-title short shimmer"></div>

              <div className="home-skeleton-line home-skeleton-line-stock shimmer"></div>

              <div className="home-skeleton-button shimmer"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
